export default __webpack_public_path__ + "static/media/login-logo.3d17273c.png";